<template>
  <div class="o-section px-3 px-lg-5">
    <div class="container">
      <breadcrumb v-if="isFirst" class="mb-8" />
      <h1
        v-if="content.headline && content.headline.length"
        class="o-section__headline mb-5"
      >
        {{ content.headline }}
      </h1>
      <div class="row">
        <div class="col-lg-4 offset-lg-0">
          <section-meta
            v-for="(item, i) in content.sidebar"
            :key="i"
            :item="item"
          />
        </div>
        <div class="col-lg-8">
          <component
            :is="item.ncContentTypeAlias"
            v-for="(item, i) in content.items"
            :key="i"
            :item="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  hydrateNever,
  hydrateWhenVisible
} from 'vue-lazy-hydration';
import contentMixin from '@/mixins/contentMixin';
import Breadcrumb from '@/components/molecules/Breadcrumb';

export default {
  name: 'SectionElement',
  components: {
    SectionMeta: hydrateWhenVisible(() => import('@/components/atoms/SectionMeta')),
    TextElement: hydrateWhenVisible(() => import('@/components/organisms/TextElement')),
    ImageElement: hydrateNever(() => import('@/components/molecules/ImageElement')),
    VideoElement: () => import('@/components/molecules/VideoElement'),
    formElement: hydrateWhenVisible(() => import('@/components/organisms/Form')),
    Qoute: hydrateNever(() => import('@/components/organisms/Qoute')),
    Breadcrumb
  },
  mixins: [contentMixin],
  props: {
    isFirst: {
      type: Boolean,
      default: false
    }
  },
}
</script>